<template>
	<div :class="{ 'letbane-layoutmodal': logoToShow === 'letbane' }">
		<div class="modal-header" :class="{ removeborder: logoToShow === 'letbane' }">
			<logo v-if="logoToShow === 'fynbus'" />
			<div class="actions">
				<div v-if="hasLocaleSwitcher && logoToShow === 'fynbus'">
					<selector-locale class="same-line" />
				</div>
				<div>
					<button
						v-if="hasCloseListener"
						type="button"
						aria-label="Close"
						class="same-line close"
						:class="{ closelarge: logoToShow === 'letbane' }"
						@click="$emit('close')"
					>
						<img v-if="logoToShow === 'letbane'" aria-hidden="true" src="@/apps/fynbus/assets/images/close-button.svg" />
						<span v-else aria-hidden="true"> × </span>
					</button>
				</div>
			</div>
		</div>
		<div class="modal-body-wrapper">
			<div class="modal-body">
				<slot />
			</div>
		</div>
		<div class="modal-footer">
			<slot name="footer" />
		</div>
	</div>
</template>

<script>
const SelectorLocale = () => ({
	component: import(
		/* webpackMode: "eager", webpackChunkName: "selector-locale" */ process.env.VUE_APP_LOCALESELECTOR_TYPE === 'FlagLocaleSelector'
			? '@/components/selectors/SelectorLocaleFlag'
			: '@/components/selectors/SelectorLocaleText'
	)
})

export default {
	props: {
		logoToShow: {
			type: String,
			required: false,
			default: 'fynbus'
		}
	},
	components: {
		SelectorLocale
	},
	computed: {
		hasCloseListener() {
			// We only show the close button if the close event is being listened on
			return this.$listeners && this.$listeners.close
		},
		hasLocaleSwitcher() {
			return JSON.parse(process.env.VUE_APP_AVAILABLE_LANGUAGES).length > 1
		}
	}
}
</script>

<style>
.letbane-layoutmodal {
	height: auto;
	max-height: 80vh;
	display: flex;
	flex-direction: column;
}

.letbane-layoutmodal .actions {
	margin-left: auto;
}

.modal-header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 0.9375rem;
	border-bottom: 0.0625rem solid rgb(229, 229, 229);
}

.modal-header.removeborder {
	border-bottom: none;
}

.modal-header .logo {
	max-height: 3.4375rem;
}

.modal-header .actions {
	display: flex;
	align-items: center;
}

.modal-header .close {
	font-size: 1.3125rem;
	font-weight: 700;
	color: #000;
	text-shadow: 0 0.0625rem 0 #fff;
	filter: alpha(opacity=50);
	opacity: 0.4;
	margin-left: 0.625rem;
	appearance: none;
	padding: 0;
	cursor: pointer;
	background: 0 0;
	border: 0;
}

.modal-header .closelarge {
	filter: none;
	opacity: 1;
}

.modal-body,
.modal-footer {
	position: relative;
	padding: 0.9375rem;
}

.horizontal-spacer {
	margin-left: 0.5em;
	margin-right: 0.5em;
}

.same-line {
	display: inline-block;
}
</style>

<style scoped lang="scss">
@mixin custom-scroll {
	scrollbar-width: thin;
	scrollbar-color: rgb(192, 192, 192) var(--color-white);

	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;

		&-button:end:increment {
			height: 4%;
			display: block;
			background: transparent;
		}
	}

	/* Track */
	&::-webkit-scrollbar-track {
		background: var(--color-white);
	}

	/* Handle */
	&::-webkit-scrollbar-thumb {
		background: rgb(192, 192, 192);
		border-radius: 3px;
	}

	/* Handle on hover */
	&::-webkit-scrollbar-thumb:hover {
		background: rgb(143, 142, 142);
		border-radius: 3px;
	}
}

.letbane-layoutmodal {
	.modal-header {
		padding: 0.9375rem 0.9375rem 0.3125rem 0.9375rem;
	}

	.modal-body-wrapper {
		overflow-y: auto;
		@include custom-scroll;
		margin-right: 0.75rem;
	}

	& .modal-body,
	& .modal-footer {
		position: relative;
		padding: 0 1.4375rem;
	}
}
</style>
